import { render, staticRenderFns } from "./ReadAccusesFilters.vue?vue&type=template&id=b5a11362"
import script from "./ReadAccusesFilters.vue?vue&type=script&lang=js"
export * from "./ReadAccusesFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports